import { TextArea, TextInput } from '@app/components';
import { Toggle } from '@app/components/form/Toggle';
import React from 'react';
import { StyledForms } from '@app/components/styled/form/Form';
import { FieldWithLabel } from '@app/components/styled/form/Label';
import { CONNECTOR_TYPE_LABELS, CREATABLE_CONNECTOR_TYPES } from '@app/common';

interface ConnectorFormProps {
  // Le type n'est choisi qu'à la création : il ne se modifie plus ensuite.
  withType?: boolean;
}

export const ConnectorForm = ({ withType = false }: ConnectorFormProps) => {
  return (
    <StyledForms.Form>

      <TextInput
        name="name"
        label="Nom"
        autoCapitalize="none" />

      {withType && (
        <FieldWithLabel label="Type">
          <Toggle
            name="type"
            helper="Le type ne pourra plus être modifié après la création"
            options={CREATABLE_CONNECTOR_TYPES.map(type => ({ title: CONNECTOR_TYPE_LABELS[type], value: type }))} />
        </FieldWithLabel>
      )}

      {/* <Toggle
        name='autoPublish'
        options={[
          { title: "Publication manuel", value: false },
          { title: "Publication automatique", value: true },
        ]} /> */}

      <TextArea
        name="description"
        label="Description"
        autoCapitalize="none" />

    </StyledForms.Form>
  );
};
